import {Icon} from "@/app/components/common/Icon";

export const LANGUAGES = [
    {
        label: 'Deutsch',
        value: 'de',
        icon: <Icon name={'de'} width={24} height={24} />,
        iso3: 'deu'
    },
    {
        label: 'English',
        value: 'en',
        icon: <Icon name={'en'} width={24} height={24} />,
        iso3: 'eng',
    },
    {
        label: 'Español',
        value: 'es',
        icon: <Icon name={'es'} width={24} height={24} />,
        iso3: 'spa',
    },
    {
        label: 'Español (Argentina)',
        value: 'es-ar',
        icon: <Icon name={'ag'} width={24} height={24} />,
        iso3: 'spa',
    },
    {
        label: 'Español (Chile)',
        value: 'es-cl',
        icon: <Icon name={'cl'} width={24} height={24} />,
        iso3: 'spa',
    },
    {
        label: 'Español (Peru)',
        value: 'es-pe',
        icon: <Icon name={'pe'} width={24} height={24} />,
        iso3: 'spa',
    },
    {
        label: 'Español (Mexico)',
        value: 'es-mx',
        icon: <Icon name={'mx'} width={24} height={24} />,
        iso3: 'spa',
    },
    {
        label: 'Français',
        value: 'fr',
        icon: <Icon name={'fr'} width={24} height={24} />,
        iso3: 'fra',
    },
    {
        label: 'Português',
        value: 'pt',
        icon: <Icon name={'pt'} width={24} height={24} />,
        iso3: 'por',
    },
    {
        label: 'Português (Brazilian)',
        value: 'pt-br',
        icon: <Icon name={'br'} width={24} height={24} />,
        iso3: 'por',
    },
    {
        label: 'Русский',
        value: 'ru',
        icon: <Icon name={'ru'} width={24} height={24} />,
        iso3: 'rus',
    },
    {
        label: '中文',
        value: 'zh',
        icon: <Icon name={'zh'} width={24} height={24} />,
        iso3: 'zho',
    },
];
